import { Grid, Typography } from '@material-ui/core';
import { AccountBalance, CreditCard } from '@material-ui/icons';
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import { useIsApplePayEnabled } from '../../../hooks/useIsApplePayEnabled';
import {
  PaymentCategory,
  PaymentProfile,
} from '../../../__generated__/pge-types';
import Modal from '../../modal';
import TextLink from '../../text-link';
import PaymentCategoryIcon from '../payment-profile-icon/PaymentCategoryIcon';
import PaymentusIFrame from '../paymentus-iframe';
import { EditProps, ProfileChangeHandler } from '../types';

type Props = {
  open: boolean;
  editProps: EditProps;
};

const EditPaymentProfile = ({ open, editProps }: Props) => {
  const { t } = useTranslation();
  const { onClose, onNew, onChange, iframeProps, invoicePayment } = editProps;
  const isApplePayEnabled = useIsApplePayEnabled();
  const isApplePayProfile = iframeProps?.pmCategory === PaymentCategory.Ap;
  const PM_CATEGORY_MAP = new Map<any, any>();

  PM_CATEGORY_MAP.set(PaymentCategory.Dd, {
    label: t('BANK_ACCOUNT'),
    icon: <AccountBalance color={'primary'} />,
  });

  PM_CATEGORY_MAP.set(PaymentCategory.Cc, {
    label: t('CREDIT_CARD'),
    icon: <CreditCard color={'primary'} />,
  });

  PM_CATEGORY_MAP.set(PaymentCategory.Dc, {
    label: t('DEBIT_CARD'),
    icon: <CreditCard color={'primary'} />,
  });

  PM_CATEGORY_MAP.set(PaymentCategory.PaypalAccount, {
    label: t('PAYPAL_ACCOUNT'),
    icon: <PaymentCategoryIcon type={PaymentCategory.PaypalAccount} />,
  });

  PM_CATEGORY_MAP.set(PaymentCategory.PaypalCredit, {
    label: t('PAYPAL_CREDIT'),
    icon: <PaymentCategoryIcon type={PaymentCategory.PaypalCredit} />,
  });
  PM_CATEGORY_MAP.set(PaymentCategory.Venmo, {
    label: t('VENMO'),
    icon: <PaymentCategoryIcon type={PaymentCategory.Venmo} />,
  });

  if (isApplePayEnabled) {
    PM_CATEGORY_MAP.set(PaymentCategory.Ap, {
      label: t('APPLE_PAY'),
      icon: <PaymentCategoryIcon type={PaymentCategory.Ap} />,
    });
  }

  PM_CATEGORY_MAP.set(PaymentCategory.Venmo, {
    label: t('VENMO'),
    icon: <PaymentCategoryIcon type={PaymentCategory.Venmo} />,
  });

  if (isApplePayProfile && !isApplePayEnabled) {
    return null;
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      children={
        <Grid container spacing={2} style={{ maxWidth: '480px' }}>
          {!!iframeProps?.token && (
            <Grid container item direction="row" justify={'flex-start'}>
              <Typography variant={'h2'}>{t('EDIT_PAYMENT_METHOD')}</Typography>
            </Grid>
          )}

          {iframeProps?.pmCategory && (
            <Grid container item direction="row" spacing={2}>
              <Grid item>
                {PM_CATEGORY_MAP.get(iframeProps?.pmCategory).icon}
              </Grid>
              <Grid item>
                <Typography variant="body1" color={'primary'}>
                  {PM_CATEGORY_MAP.get(iframeProps?.pmCategory).label}
                </Typography>
              </Grid>
            </Grid>
          )}
          <Grid container item>
            <PaymentusIFrame
              {...{
                invoicePayment,
                onChange: profile => onChange && onChange(profile),
                onNew: (profile: PaymentProfile) => onNew && onNew(profile),
                buttonLabelText: t('SAVE_CHANGES'),
                iframeProps: {
                  ...iframeProps,
                },
              }}
            ></PaymentusIFrame>
          </Grid>
        </Grid>
      }
    ></Modal>
  );
};

export default EditPaymentProfile;
